import ColumnsButton from "../common/ColumnsButton";
import { Menu, Transition } from "@headlessui/react";
import React, { Fragment, useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import {
  Check,
  ChevronDown,
  Columns3,
  EllipsisVertical,
  Filter,
  List,
  PauseCircle,
  Repeat,
  RotateCcw,
  Search,
  SlidersHorizontal,
  Trash,
  Trash2,
  User,
  UserCog,
  UserPlus,
  UserX,
  X,
} from "lucide-react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import AppContext from "../../context/AppContext";
import FieldListModal from "./FieldStaffListModal";
import { toast } from "../../utils/toast";
import Cookies from "js-cookie";
import DeletePermission from "../suspence/DeletePermission";
import {
  deleteTasks,
  putTasksOnHold,
  fetchFieldAgentMap,
  deleteAllRecords,
  unassignTask,
  generateTaskListReport,
  TaskListSearchError,
  TASK_LIST_CODES,
} from "../../service/Task";
import Modal from "../DownloadModal/Modal";
import Joyride from "react-joyride";
import translations from "../common/Translations";
import { isRTL } from "../../utils/rtl";
import ReAssignModal from "./ReAssignModal";
import { canReassignTask, isReassignExceptionWorkflow } from "../../utils/taskReassignRules";
import {
  canAssignTasks,
  canReassignByStatus,
  canUnassignTasks,
  hasCompletedTask,
  hasOnHoldTask,
  hasPendingTask,
  isOnHoldOrPending,
} from "../../utils/taskActionRules";
import CommonButton from "../common/CommonButton";
import CommonTooltip from "../common/CommonTooltip";
import ActivitySelect from "../common/task/ActivitySelect";
import { getActivityListByProjectId } from "../../service/User";
import { getPermittedActivities } from "../../utils/activityPermissions";
import DeleteTask from "../suspence/DeleteTask";
import { UnassignConfirmationModal } from "./UnassignConfirmationModal";
import { loadGroupsForDepartment } from "./GroupAssignParts";
import { getPermissionByScreenCode, isSuperAdmin } from "../../utils/permissions";
import { countActiveColumnFilters, canonicalColumnKey } from "../../utils/taskListFilters";
import ColumnsCustomizeModal from "../common/ColumnsCustomizeModal";
import ColumnAccessManagementModal from "./ColumnAccessManagementModal";
import { ShieldCheck } from "lucide-react";
import Tooltip from "../common/Tooltip";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const getBackendErrorMessage = (error) =>
  error?.response?.data?.body?.value ??
  error?.response?.data?.body?.error ??
  error?.response?.data?.message ??
  error?.body?.value ??
  error?.body?.error ??
  error?.message;

// Which search-field scope (Account No. / Area Code / etc.) was active,
// persisted the same way the field values themselves already are, so a
// refresh restores the field the user was actually searching by instead of
// silently falling back to the default "Account No." scope.
const TASK_SEARCH_FIELD_KEY_STORAGE = "taskSearchFieldKey";
const readPersistedSearchFieldKey = () => {
  try {
    return sessionStorage.getItem(TASK_SEARCH_FIELD_KEY_STORAGE) || localStorage.getItem(TASK_SEARCH_FIELD_KEY_STORAGE) || null;
  } catch {
    return null;
  }
};
const persistSearchFieldKey = (key) => {
  try {
    if (key) {
      sessionStorage.setItem(TASK_SEARCH_FIELD_KEY_STORAGE, key);
      localStorage.setItem(TASK_SEARCH_FIELD_KEY_STORAGE, key);
    } else {
      sessionStorage.removeItem(TASK_SEARCH_FIELD_KEY_STORAGE);
      localStorage.removeItem(TASK_SEARCH_FIELD_KEY_STORAGE);
    }
  } catch (error) {
    console.error("Error persisting task search field key:", error);
  }
};

const TaskListToolbar = ({
  selectedTasks, setSelectedTasks,
  openTab,
  setOpenTab,
  isChecked,
  selectedtask,
  setIsChecked,
  fromDate,
  setFromDate,
  toDate,
  setToDate,
  setselectedtask,
  finishedStatus,
  assigneesToUnassign, setAssigneesToUnassign,
  totalPageSize = 0,
  provideTasksWithMissingLatAndLong = false,
  setProvideTasksWithMissingLatAndLong,
  tableHeaders = [],
  visibleColumnKeys = [],
  setVisibleColumnKeys,
  onColumnSelectionApply,
  setFinishedStatus, aiSourceFilter, setAiSourceFilter,
  onFiltersReset,
  showTableFilters = true,
  onToggleTableFilters = () => { },
  searchFields = [],
  noColumnAccess = false,
  exportRequest = null,
}) => {
  const [open, setOpen] = useState(false);
  const [openReassign, setOpenReassign] = useState(false);
  const [searchFieldKey, setSearchFieldKey] = useState(() => readPersistedSearchFieldKey());
  const [isFieldPickerOpen, setIsFieldPickerOpen] = useState(false);
  const [fieldPickerQuery, setFieldPickerQuery] = useState("");
  const fieldPickerRef = useRef(null);
  const navigate = useNavigate();
  const context = useContext(AppContext);
  const {
    setPriority,
    setActive,
    selectAll,
    setSelectAll,
    setAreaCode,
    areaCode,
    accountNo,
    setAccountNo,
    setFieldAgentList,
    fieldAgentList,
    setSelectedUserId,
    priority,
    active,
    taskData,
    setTaskData,
    setTotalPageSize,
    bumpTaskListFetchEpoch,
    selectedOrgId,
    setSelectedOrgId,
    langMode,
    tasktollbar,
    runTour,
    userType,
    setSelectedUserName,
    setWorkflowName,
    workflowName,
    activityId,
    projectId, activityLoader,
    renderedTaskCount,
    setHeaderActivitySelect,
  } = context;
  const [selectedStatusName, setselectedStatusName] = useState("Select Status");
  const [selectedPriorityName, setselectedPriorityName] =
    useState("Select Priority");
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [deleteItemId, setDeleteItemId] = useState("");
  const [deleteItemType, setDeleteItemType] = useState("");
  const [downloadModal, setDownloadModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false); // Loader state
  const location = useLocation(); // Get the current route
  const [unassign, setUnassign] = useState(false);
  const [assigneeId, setAssigneeId] = useState();
  const [inputValue, setInputValue] = useState(""); // Temporary state for input
  const [selectItemColor, setSelectItemColor] = useState("");
  const [selectItemColor1, setSelectItemColor1] = useState("");
  const [selectItemColor2, setSelectItemColor2] = useState("");
  const [areainputValue, setAreaInputValue] = useState(""); // Temporary state for input
  const [activity, setActivity] = useState([])
  const [isLoader, setLoader] = useState(false)
  const [comment, setComment] = useState("");
  const [showUnassignModal, setShowUnassignModal] = useState(false);
  const [selectedAssigneesToUnassign, setSelectedAssigneesToUnassign] = useState([]);
  // ------- group assign -------- start
  const [availableGroups, setAvailableGroups] = useState([]);
  const [selectedUnassignGroupId, setSelectedUnassignGroupId] = useState(null);
  // ------- group assign -------- end
  const [isAiSearchOpen, setIsAiSearchOpen] = useState(false);
  const [aiSearchQuery, setAiSearchQuery] = useState("");
  const [isColumnsModalOpen, setIsColumnsModalOpen] = useState(false);
  const columnsButtonRef = useRef(null);
  const [isColumnAccessModalOpen, setIsColumnAccessModalOpen] = useState(false);
  const [hasActiveTableFilters, setHasActiveTableFilters] = useState(false);
  const [activeTableFilterCount, setActiveTableFilterCount] = useState(0);
  const searchHydratedRef = useRef(false);
  const areaHydratedRef = useRef(false);
  const aiSearchInitializedRef = useRef(false);
  const [dropdownStyle, setDropdownStyle] = useState({
    top: 0,
    left: 0,
  });
  const aiSearchRef = useRef(null);
  const modalRef = useRef(null);
  const filtersToggleRef = useRef(null);
  const [isFiltersFlyoutOpen, setIsFiltersFlyoutOpen] = useState(false);
  const customVarPerm = getPermissionByScreenCode("TASK_MANAGEMENT");
  const isRtl = isRTL(langMode);

  useEffect(() => {
    const savedSearch = sessionStorage.getItem("taskSearchValue");
    if (savedSearch) {
      setAccountNo(savedSearch);
      setInputValue(savedSearch)
    }
    searchHydratedRef.current = true;
  }, []);

  useEffect(() => {
    const mainElement = document.querySelector('main');
    if (mainElement) {
      mainElement.classList.add('w-full');
    }
    return () => {
      if (mainElement) {
        mainElement.classList.remove('w-full');
      }
    };
  }, [activity]);

  // Calculate Position When Opening
  const toggleAiSearch = () => {
    if (!isAiSearchOpen && aiSearchRef.current) {
      const rect = aiSearchRef.current.getBoundingClientRect();

      setDropdownStyle({
        top: rect.bottom + 8,
        left: rect.right - 310,
      });
    }

    setIsAiSearchOpen(prev => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      const clickedOutsideButton = aiSearchRef.current && !aiSearchRef.current.contains(event.target)
      const clickedOutsideModal = modalRef.current && !modalRef.current.contains(event.target);

      if (clickedOutsideButton && clickedOutsideModal) {
        setIsAiSearchOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const filtersTooltipText = useMemo(
    () =>
      translations[langMode]?.filtersLabel ??
      "Filters",
    [langMode]
  );

  useEffect(() => {
    if (!isFiltersFlyoutOpen) return;
    const onDocDown = (e) => {
      if (filtersToggleRef.current?.contains(e.target)) return;
      setIsFiltersFlyoutOpen(false);
    };
    document.addEventListener("mousedown", onDocDown);
    return () => document.removeEventListener("mousedown", onDocDown);
  }, [isFiltersFlyoutOpen]);

  useEffect(() => {
    if (!isFieldPickerOpen) return;
    const onDocDown = (e) => {
      if (fieldPickerRef.current?.contains(e.target)) return;
      setIsFieldPickerOpen(false);
      setFieldPickerQuery("");
    };
    document.addEventListener("mousedown", onDocDown);
    return () => document.removeEventListener("mousedown", onDocDown);
  }, [isFieldPickerOpen]);

  const activeSearchField = useMemo(() => {
    if (!searchFields.length) return null;
    const found = searchFields.find(
      (f) =>
        f.key === searchFieldKey ||
        (searchFieldKey && canonicalColumnKey(f.key) === canonicalColumnKey(searchFieldKey))
    );
    return (
      found ||
      searchFields.find((f) => canonicalColumnKey(f.key) === "accountno") ||
      searchFields[0]
    );
  }, [searchFields, searchFieldKey]);

  useEffect(() => {
    persistSearchFieldKey(searchFieldKey);
  }, [searchFieldKey]);

  const filteredSearchFields = useMemo(() => {
    const q = fieldPickerQuery.trim().toLowerCase();
    if (!q) return searchFields;
    return searchFields.filter((f) => f.label.toLowerCase().includes(q));
  }, [searchFields, fieldPickerQuery]);

  const { theme } = useContext(AppContext);
  const priorityoptions = [
    { id: "Everything", value: "Everything" },
    { id: "Low_Priority", value: "Low Priority" },
    { id: "Medium_Priority", value: "Medium Priority" },
    { id: "High_Priority", value: "High Priority" },
  ];
  const activeoptions = [
    { id: "Everything", value: "Everything" },
    { id: "Active", value: "Active" },
    { id: "Assigned", value: "Assigned" },
    { id: "In_Progress", value: "In Progress" },
    { id: "Completed", value: "Completed" },
    { id: "On_Hold", value: "On Hold" },
    { id: "Pending", value: "Pending" },
    { id: "Finished", value: "Finished" },
  ];
  const handleShowModal = () => {

    if (!activityId) {
      toast.warn(translations[langMode].selectWorkflowFirst);
      return;
    }
    setDownloadModal(true);

  };
  const showDeleteModal = (type, id) => {
    if (!activityId) {
      toast.warn(translations[langMode].selectWorkflowFirst);
      return;
    }
    if (type === "single" && !selectedtask?.length) {
      toast.warn(translations[langMode].plzselectatleatone);
      return;
    }
    if (type === "single" && !customVarPerm?.canDelete) {
      return;
    }
    setComment("");
    setDeleteItemType(type);
    setDeleteItemId(id);
    setDeleteModalOpen(true);
  };

  const handleOnHoldClick = (e) => {
    e?.preventDefault?.();
    if (!customVarPerm?.canUpdate) {
      return;
    }
    if (!activityId) {
      toast.warn(translations[langMode].selectWorkflowFirst);
      return;
    }
    if (!selectedtask?.length) {
      toast.warn(translations[langMode].plzselectatleatone);
      return;
    }
    const tasksToHold = resolveSelectedTasks();
    if (hasCompletedTask(tasksToHold)) {
      toast.warn(translations[langMode]?.completedTasksCannotBeOnHold || "Completed tasks cannot be put on hold.");
      return;
    }
    if (hasPendingTask(tasksToHold)) {
      toast.warn(translations[langMode]?.pendingTasksCannotBeOnHold || "Pending tasks cannot be put on hold.");
      return;
    }
    if (hasOnHoldTask(tasksToHold)) {
      toast.warn(translations[langMode]?.taskAlreadyOnHold || "Task is already on hold.");
      return;
    }
    handleTaskHold(selectedtask);
  };

  const handleCloseDeleteModal = () => {
    setComment("");
    setDeleteModalOpen(false);
  };

  const handleClearSelection = () => {
    setIsChecked(false);
    setSelectAll(false);
    setselectedtask([]);
    if (typeof setSelectedTasks === "function") setSelectedTasks([]);
  };
  const clearTaskFilters = ({ resetOrganization = false } = {}) => {
    setPriority("Everything");
    setActive("Everything");
    setSelectedUserId("");
    setSelectedUserName("Default");
    if (resetOrganization) {
      setSelectedOrgId("");
    }
    setSelectItemColor("");
    setSelectItemColor1("");
    setSelectItemColor2("");
    setAccountNo('');
    setAreaCode('');
    setInputValue("");
    setAreaInputValue("");
    setSearchFieldKey(null);
    persistSearchFieldKey(null);
    setselectedPriorityName("Select Priority");
    setselectedStatusName("Select Status");
    setFromDate("");
    setToDate("");
    setProvideTasksWithMissingLatAndLong?.(false);
    setAiSourceFilter?.("");
    Cookies.remove("mapListFilters");
    sessionStorage.removeItem("taskSearchValue");
    sessionStorage.removeItem("taskSearchValueBackup");
    localStorage.removeItem("taskSearchValueBackup");
    sessionStorage.removeItem("from_Date");
    sessionStorage.removeItem("to_Date");
    sessionStorage.removeItem("taskManageTableFilters");
    sessionStorage.removeItem("taskManageScreenState");
    window.dispatchEvent(new Event("taskManageFiltersChanged"));
    onFiltersReset?.();
  };

  const resetFilters = () => {
    clearTaskFilters({ resetOrganization: true });
  };

  const handleResetFiltersOnly = () => {
    clearTaskFilters({ resetOrganization: false });
  };

  const handleSetMapListFilters = (key, value) => {
    try {
      let mapListData = Cookies.get("mapListFilters");
      mapListData = mapListData ? JSON.parse(mapListData) : {};
      mapListData[key] = value;
      Cookies.set("mapListFilters", JSON.stringify(mapListData));
    } catch (error) {
      console.error("Error updating mapListFilters cookie:", error);
    }
  }

  // Selected tasks are stored as snapshots taken when the checkbox was ticked,
  // so their taskStatus / assignees go stale once the list is refreshed. Always
  // resolve the selection against the current taskData first and only fall
  // back to the snapshot for rows that are not on the loaded page.
  const resolveSelectedTasks = () => {
    const snapshots = new Map((Array.isArray(selectedTasks) ? selectedTasks : []).map((t) => [String(t?.taskId), t]));
    const liveRows = new Map((Array.isArray(taskData) ? taskData : []).map((t) => [String(t?.taskId), t]));
    const ids = selectedtask?.length ? selectedtask.map((id) => String(id)) : Array.from(snapshots.keys());
    return ids.map((id) => liveRows.get(id) ?? snapshots.get(id)).filter(Boolean);
  };

  const handleAssignClick = (e) => {
    e?.preventDefault?.();
    if (!customVarPerm?.canUpdate) {
      return;
    }
    if (!activityId) {
      toast.warn(translations[langMode].selectWorkflowFirst);
      return;
    }
    if (!selectedtask?.length) {
      toast.warn(translations[langMode].plzselectatleatone);
      return;
    }
    if (!canAssignTasks(resolveSelectedTasks())) {
      toast.warn(translations[langMode]?.taskAssignNotAllowed || "Only Active, Pending or On Hold tasks can be assigned.");
      return;
    }
    setOpen(true);
  };

  const handleReassignClick = (e) => {
    e?.preventDefault?.();
    if (!customVarPerm?.canUpdate) {
      return;
    }
    if (!activityId) {
      toast.warn(translations[langMode].selectWorkflowFirst);
      return;
    }
    if (!selectedtask?.length) {
      toast.warn(translations[langMode].plzselectatleatone);
      return;
    }
    const selectedTasksResolved = resolveSelectedTasks();
    const blockedTasks = selectedTasksResolved.filter((task) => !canReassignTask(task, activityId));
    if (blockedTasks.length > 0) {
      // Only workflows with the unsuccessful-completed exception get the
      // specific message; any other blocked Completed task gets the generic one.
      const inExceptionWorkflow = blockedTasks.some((task) => isReassignExceptionWorkflow(task, activityId));
      toast.warn(
        inExceptionWorkflow
          ? translations[langMode].completedTaskReassignNotAllowed || "Only unsuccessful completed tasks can be reassigned."
          : translations[langMode]?.taskReassignNotAllowed || "Only Assigned, In Progress, Pending or On Hold tasks can be reassigned."
      );
      return;
    }
    if (!canReassignByStatus(selectedTasksResolved)) {
      toast.warn(translations[langMode]?.taskReassignNotAllowed || "Only Assigned, In Progress, Pending or On Hold tasks can be reassigned.");
      return;
    }
    setOpenReassign(true);
  };


  const handleUnassignButtonClick = () => {
    if (!customVarPerm?.canUpdate) {
      return;
    }
    const selectedTasksResolved = resolveSelectedTasks();
    if (selectedTasksResolved.length === 0) {
      toast.warn(translations[langMode].notaskavbtounasign);
      return;
    }
    if (!canUnassignTasks(selectedTasksResolved)) {
      toast.warn(translations[langMode]?.taskUnassignNotAllowed || "Only Assigned, Pending or On Hold tasks can be unassigned.");
      return;
    }
    const allAssignees = selectedTasksResolved.flatMap((task) => task.assignees || []);
    let uniqueAssignees = Array.from(new Set(allAssignees.map((a) => a.assigneeId)))
      .map((userId) => allAssignees.find((a) => a.assigneeId === userId));
    // Assigned tasks whose row carries no assignee objects fall back to the
    // field agent list. On Hold / Pending tasks can genuinely have no assignee,
    // so they must not list every field agent.
    const shouldFallbackToFieldAgents = selectedTasksResolved.some((task) => !isOnHoldOrPending(task));
    if (uniqueAssignees.length === 0 && shouldFallbackToFieldAgents && Array.isArray(fieldAgentList)) {
      uniqueAssignees = fieldAgentList.map((agent) => ({
        assigneeId: agent.userId ?? agent.id,
        assigneeName: agent.name ?? agent.userName,
      }));
    }
    setAssigneesToUnassign(uniqueAssignees);
    setSelectedAssigneesToUnassign([]);
    // ------- group assign -------- start
    setSelectedUnassignGroupId(null);
    loadGroupsForDepartment().then(setAvailableGroups);
    // ------- group assign -------- end
    setShowUnassignModal(true);
  };

  const handleToggleAllAssignees = () => {
    if (selectedAssigneesToUnassign.length === assigneesToUnassign.length) {
      setSelectedAssigneesToUnassign([]);
    } else {
      const allIds = assigneesToUnassign.map((a) => a.assigneeId);
      setSelectedAssigneesToUnassign(allIds);
    }
  };

  const handleToggleAssignee = (assigneeId) => {
    setSelectedAssigneesToUnassign((prevSelected) =>
      prevSelected.includes(assigneeId)
        ? prevSelected.filter((id) => id !== assigneeId)
        : [...prevSelected, assigneeId]
    );
  };

  const handleUnassign = async () => {
    try {
      // ------- group assign -------- start
      // Assignees and group are independent; send whichever (or both) are selected.
      const hasGroup = selectedUnassignGroupId != null;
      const hasAssignees = Array.isArray(selectedAssigneesToUnassign) && selectedAssigneesToUnassign.length > 0;
      if (!hasGroup && !hasAssignees) {
        toast.warn(translations[langMode]?.noAssigneesOrGroupForUnassign ?? "No assignees or group selected for unassigning.");
        return;
      }

      const resolvedTasks = resolveSelectedTasks();
      const allTaskIds = new Set();
      if (hasGroup) {
        // Group unassign targets every selected task.
        resolvedTasks.forEach((task) => allTaskIds.add(task.taskId));
      }
      if (hasAssignees) {
        selectedAssigneesToUnassign.forEach(assigneeId => {
          const tasksForThisAssignee = resolvedTasks.filter(task =>
            (task.assignees || []).some(a => a.assigneeId === assigneeId)
          );
          tasksForThisAssignee.forEach(task => allTaskIds.add(task.taskId));
        });
      }

      const payload = {
        workflowId: parseInt(activityId),
        taskIds: Array.from(allTaskIds),
        ...(hasAssignees ? { assigneeId: selectedAssigneesToUnassign } : {}),
        ...(hasGroup ? { groupId: selectedUnassignGroupId } : {}),
      };
      // ------- group assign -------- end
      console.log("Payload being sent:", payload);

      const data = await unassignTask(payload);

      if (data.header.code === 600) {
        toast.success(data.body.value);
        if (typeof bumpTaskListFetchEpoch === "function") {
          bumpTaskListFetchEpoch();
        }
        setIsChecked(false);
        handleCloseDeleteModal();

        const toRemove = new Set(selectedAssigneesToUnassign);
        const affectedIds = new Set(
          Array.from(allTaskIds).map((id) => String(id))
        );
        setTaskData((prev) => {
          if (!Array.isArray(prev)) return prev;
          return prev.map((task) => {
            const idKey = String(task.taskId);
            if (!affectedIds.has(idKey)) return { ...task, isChecked: false };
            const newAssignees = (task.assignees || []).filter(
              (a) => !toRemove.has(a.assigneeId)
            );
            const newStatus =
              newAssignees.length === 0 ? "Active" : task.taskStatus;
            return {
              ...task,
              assignees: newAssignees,
              taskStatus: newStatus,
              isChecked: false,
            };
          });
        });
        setSelectedTasks([]);
        setSelectAll(false);
        setselectedtask([]);
        setShowUnassignModal(false);
        setAssigneesToUnassign([]);
        setSelectedAssigneesToUnassign([]);
        setSelectedUnassignGroupId(null);
        handleResetFiltersOnly();
      } else {
        const backendMessage =
          data?.body?.error ??
          data?.body?.value ??
          data?.header?.message;
        if (backendMessage) {
          toast.error(backendMessage);
        }
      }
    } catch (error) {
      console.error("Failed to unassign task:", error);
      const backendMessage = getBackendErrorMessage(error);
      if (backendMessage) {
        toast.error(backendMessage);
      }
    }
  };


  const taskDeleteList = async () => {
    if (!selectedtask?.length) {
      toast.warn(translations[langMode].plzselectatleatone);
      return;
    }
    if (!comment) {
      toast.error(translations[langMode].plzenteracommentbeforedel);
      return;
    }
    try {
      const data = await deleteTasks(selectedtask, comment);
      setIsChecked(false);
      setselectedtask([]);
      if (typeof setSelectedTasks === "function") {
        setSelectedTasks([]);
      }
      setOpen(false);
      const updatedTaskData = taskData.filter(
        (task) => !selectedtask.includes(task.taskId)
      );
      setTaskData(updatedTaskData);
      if (!selectAll) {
        toast.success(translations[langMode].taskdelsuccessfully);
      }
      handleCloseDeleteModal();
      // The line above only trims the already-loaded page in local state --
      // it doesn't refresh totalPageSize or refill the page from the server.
      // On a later pagination page, deleting every remaining row here left the
      // page blank (with a stale totalPageSize) until a full reload reset
      // currentPage back to 0. Re-fetching from the server keeps the current
      // page and total count authoritative after a delete.
      if (typeof bumpTaskListFetchEpoch === "function") {
        bumpTaskListFetchEpoch();
      }
    } catch (error) { }
  };

  const handleAreaCodeChange = (event) => {
    setAreaInputValue(event.target.value);
    handleSetMapListFilters("areaInput", event?.target?.value)
  };


  useEffect(() => {
    const storedPriority = Cookies.get("mapListFilters");
    if (storedPriority) {
      const parsedPriority = JSON.parse(storedPriority);

      setselectedPriorityName(parsedPriority?.selectedPriority);
      setselectedStatusName(parsedPriority?.selectedStatus);
      setAreaInputValue(parsedPriority?.areaInput)

      if (Array.isArray(priorityoptions)) {
        const selectedOption = priorityoptions.find(
          (option) => option.value === parsedPriority?.selectedPriority
        );
        if (selectedOption) {
          setSelectItemColor1(theme === "dark" ? "white" : "black");
        }

      }
      if (Array.isArray(fieldAgentList)) {
        const selectedAgent = (fieldAgentList || [])?.find(
          (agent) => agent.userId === parsedPriority?.selectedUserId
        );
        if (selectedAgent) {
          setSelectedUserName(selectedAgent.name);
        }
      }
    }

    areaHydratedRef.current = true;
  }, [priorityoptions, theme, fieldAgentList]);


  const handleInputChange = (event) => {
    setInputValue(event.target.value); // Update temporary state
  };

  const handleSearch = () => {
    setAccountNo(inputValue); // Set the final value on search
    sessionStorage.setItem("taskSearchValue", inputValue); // Save value in sessionStorage
  };

  const handleAreacodeSearch = () => {
    setAreaCode(areainputValue);
  };

  useEffect(() => {
    if (!areaHydratedRef.current) return;
    if (areainputValue?.length === 0) {
      handleAreacodeSearch();
    }
  }, [areainputValue]);
  useEffect(() => {
    if (!searchHydratedRef.current) return;
    if (inputValue?.length === 0) {
      handleSearch();
    }
  }, [inputValue]);

  useEffect(() => {
    const fetchFieldAgents = async () => {
      try {
        const agents = await fetchFieldAgentMap(selectedOrgId);
        setFieldAgentList(agents.body.value);
      } catch (error) {
        console.error("An error occurred:", error);
      }
    };
    fetchFieldAgents();
  }, [selectedOrgId]);

  useEffect(() => { }, [fieldAgentList]);

  const handleAssigneeChange = (selectedId) => {
    setSelectedUserId(selectedId);
    handleSetMapListFilters("selectedUserId", selectedId)
    const selectedAgent = fieldAgentList.find(
      (agent) => agent.userId === selectedId
    );
    if (selectedAgent) {
      setSelectedUserName(selectedAgent.name);
      setAssigneeId(selectedAgent.userId);
      setSelectItemColor2(theme === "dark" ? "white" : "black");
    } else if (selectedId === "") {
      setSelectedUserName("Default");
    }
  };

  const handleDeleteAllRecord = async (workflowId) => {
    if (!comment) {
      toast.error(translations[langMode].plzenteracommentbeforedel);
      return;
    }
    try {
      setLoader(true)
      const responseData = await deleteAllRecords(workflowId, comment, {
        assigneeIds: exportRequest?.assigneeIds,
        provideTasksWithMissingLatAndLong: exportRequest?.provideTasksWithMissingLatAndLong,
        columnFilters: exportRequest?.columnFilters,
      });
      if (responseData.header.code === 600) {
        setTaskData([]);
        if (typeof setTotalPageSize === "function") {
          setTotalPageSize(0);
        }
        setIsChecked(false);
        setselectedtask([]);
        if (typeof setSelectedTasks === "function") {
          setSelectedTasks([]);
        }
        toast.success(
          (typeof responseData?.body?.value === "string" && responseData.body.value) ||
          translations[langMode].delteallrecord
        );
        setLoader(false);
        handleCloseDeleteModal();
        if (typeof bumpTaskListFetchEpoch === "function") {
          bumpTaskListFetchEpoch();
        }
      } else {
        setLoader(false)
        const backendMessage =
          responseData?.body?.value ??
          responseData?.body?.error ??
          responseData?.header?.message;
        if (backendMessage) {
          toast.error(backendMessage);
        }
      }
    } catch (error) {
      setLoader(false)
      console.error("Error:", error.message);
      const backendMessage = getBackendErrorMessage(error);
      if (backendMessage) {
        toast.error(backendMessage);
      }
    }
  };

  const handleTabChange = (tab) => {
    setOpenTab(tab);
    localStorage.setItem("activeTab", tab);
  };

  // Number of filters actually going into the export payload, published by
  // TaskListView. Deliberately not activeTableFilterCount: that one is derived
  // from the persisted filter blob for the funnel badge and counts entries the
  // request may never send (denied columns, the 15-filter cap).
  const exportFilterCount = exportRequest?.filterCount ?? 0;

  const exportButtonLabel = useMemo(() => {
    const base = translations[langMode]?.exportBtn ?? "Export";
    if (!exportFilterCount) return base;
    const suffix =
      exportFilterCount === 1
        ? translations[langMode]?.exportOneFilter ?? "1 filter"
        : (translations[langMode]?.exportManyFilters ?? "{count} filters").replace(
          "{count}",
          exportFilterCount
        );
    return `${base} (${suffix})`;
  }, [langMode, exportFilterCount]);

  const unfilteredExportWarning = useMemo(
    () =>
      exportFilterCount === 0
        ? translations[langMode]?.exportNoFiltersWarning ??
        "No filters are applied, so this exports every task in the selection. On a large workflow the file can take a long time to build."
        : "",
    [langMode, exportFilterCount]
  );

  // Delete All Record follows the same filter set as the export: with filters
  // applied only the matching tasks are deleted, otherwise the whole activity.
  // The "(1 filter)" wording is shared with the Export button.
  const deleteFilterLabel =
    exportFilterCount === 1
      ? translations[langMode]?.exportOneFilter ?? "1 filter"
      : (translations[langMode]?.exportManyFilters ?? "{count} filters").replace(
        "{count}",
        exportFilterCount
      );

  const deleteAllLabel = `${translations[langMode].deleteAllRecord}${exportFilterCount > 0 ? ` (${deleteFilterLabel})` : ""}`;

  const deleteAllScopeMessage =
    exportFilterCount > 0
      ? (translations[langMode]?.deleteAllFilteredMessage ??
        "{filters} applied. Only the tasks matching the applied filters will be deleted.").replace("{filters}", deleteFilterLabel)
      : translations[langMode]?.deleteAllUnfilteredMessage ??
      "No filters applied. All tasks in this activity will be deleted.";

  const deleteAllTooltip =
    exportFilterCount > 0
      ? translations[langMode]?.deleteAllFilteredTooltip ??
      "Delete only the tasks that match the applied filters"
      : translations[langMode]?.deleteAllUnfilteredTooltip ??
      "Delete all tasks in this activity";

  /**
   * Queues an Excel export of exactly the rows the grid is currently showing.
   *
   * The payload is whatever TaskListView last sent to list/search, read at
   * click time -- so a filter changed after this point lands in the next
   * export, never in the one already queued.
   *
   * "All activity" swaps workflow scope for project scope: the endpoint takes
   * projectId as an alternative to workflowIds, so the body's workflowIds go
   * empty rather than being sent alongside it.
   *
   * Nothing is downloaded here. The response is an acknowledgement; the
   * workbook shows up in the Recent Reports list in this same modal once the
   * backend has built it.
   */
  const downloadFiltration = async (selectedOption) => {
    if (isLoading) return;

    const exportWholeProject = selectedOption === "all";

    if (exportWholeProject && !projectId) {
      toast.warn(
        translations[langMode]?.selectProjectForFullExport ??
        "Select a project before exporting all activities."
      );
      return;
    }
    if (!exportWholeProject && !activityId) {
      toast.warn(translations[langMode].selectWorkflowFirst);
      return;
    }

    setIsLoading(true);
    try {
      await generateTaskListReport({
        workflowIds: exportWholeProject ? [] : exportRequest?.workflowIds ?? activityId,
        projectId: exportWholeProject ? projectId : undefined,
        assigneeIds: exportRequest?.assigneeIds,
        provideTasksWithMissingLatAndLong: exportRequest?.provideTasksWithMissingLatAndLong,
        columnFilters: exportRequest?.columnFilters,
      });
      // Acknowledgement only -- the file is delivered through Recent Reports.
      toast.success(translations[langMode].reportRequestQueued);
    } catch (error) {
      // 601/605/608 arrive as HTTP 200 with the real status in header.code, so
      // they surface as TaskListSearchError rather than an axios failure.
      if (error instanceof TaskListSearchError) {
        if (error.code === TASK_LIST_CODES.ACCESS_DENIED) {
          toast.error(
            translations[langMode]?.accessDenied ?? "You do not have access to these tasks."
          );
        } else if (error.code === TASK_LIST_CODES.TOKEN_EXPIRED) {
          // App.js owns session teardown and the redirect.
          toast.error(
            translations[langMode]?.sessionExpired ??
            "Your session has expired. Please sign in again."
          );
        } else {
          toast.error(error.message);
        }
      } else {
        console.error("Error queuing task export:", error);
        const backendMessage = getBackendErrorMessage(error);
        if (backendMessage) {
          toast.error(backendMessage);
        }
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleMapView = () => {
    navigate("/maptask");
  };

  const handleGoCsv = () => {
    Cookies.set("viewMode", "list");
    navigate("/task/import-csv");
  };
  const handleGoCreateTask = () => {
    Cookies.set("viewmode", "list");
    navigate("/task/create-task");
  };
  const handleTaskHold = async (selectedtask) => {
    if (!selectedtask?.length) {
      toast.warn(translations[langMode].plzselectatleatone);
      return;
    }
    let uniqueTasks = Array.from(new Set(selectedtask));
    try {
      const response = await putTasksOnHold(uniqueTasks);
      if (response.header.code === 600) {
        toast.success(translations[langMode]?.taskOnHoldSuccess ?? "Task on hold");
        if (typeof bumpTaskListFetchEpoch === "function") {
          bumpTaskListFetchEpoch();
        }
        const idSet = new Set(uniqueTasks.map((id) => String(id)));
        setTaskData((prev) => {
          if (!Array.isArray(prev)) return prev;
          return prev.map((task) => {
            if (!idSet.has(String(task.taskId))) return task;
            return { ...task, taskStatus: "On_Hold", isChecked: false };
          });
        });
        setIsChecked(false);
        setSelectAll(false);
        setSelectedTasks([]);
        setselectedtask([]);
        uniqueTasks = [];
      } else {
        const backendMessage =
          response?.body?.value ??
          response?.body?.error ??
          response?.header?.message;
        if (backendMessage) {
          toast.error(backendMessage);
        }
      }
    } catch (error) {
      console.error("Error putting tasks on hold:", error);
      const backendMessage = getBackendErrorMessage(error);
      if (backendMessage) {
        toast.error(backendMessage);
      }
    }
  };

  useEffect(() => {
    const savedValue = sessionStorage.getItem("taskSearchValue");
    if (savedValue) {
      setAccountNo(savedValue);
    }
  }, []);

  const handleClick = () => {
    if (!isChecked) {
      toast.error(translations[langMode]?.selectTaskBeforeProceeding ?? "Please select a task before proceeding!");
    }
  };

  const handleApplyColumnsModal = (nextVisibleKeys = []) => {
    if (typeof onColumnSelectionApply === "function") {
      onColumnSelectionApply(nextVisibleKeys);
      return;
    }
    if (typeof setVisibleColumnKeys !== "function") return;
    setVisibleColumnKeys(nextVisibleKeys);
  };
  const applyKeywordFilters = (query) => {
    const normalizedQuery = query.toLowerCase();
    const statusMap = {
      active: "Active",
      assigned: "Assigned",
      completed: "Completed",
      "in progress": "In_Progress",
      in_progress: "In_Progress",
      "on hold": "On_Hold",
      on_hold: "On_Hold",
      pending: "Pending",
      finished: "Finished",
      everything: "Everything",
      all: "Everything",
    };
    const priorityMap = {
      high: "High_Priority",
      "high priority": "High_Priority",
      medium: "Medium_Priority",
      "medium priority": "Medium_Priority",
      low: "Low_Priority",
      "low priority": "Low_Priority",
    };
    const words = normalizedQuery.split(/\s+/);
    let matchedStatus = null;
    let matchedPriority = null;
    for (const word of words) {
      if (statusMap[word] !== undefined) matchedStatus = statusMap[word];
      if (priorityMap[word] !== undefined) matchedPriority = priorityMap[word];
    }
    if (statusMap[normalizedQuery] !== undefined) matchedStatus = statusMap[normalizedQuery];
    if (priorityMap[normalizedQuery] !== undefined) matchedPriority = priorityMap[normalizedQuery];
    setActive(matchedStatus ?? "Everything");
    setFinishedStatus(matchedStatus ?? "Everything");
    setPriority(matchedPriority ?? "Everything");
    setAiSourceFilter(normalizedQuery);
  };

  const computeActiveTableFilterCount = useCallback(() => {
    try {
      const rawFilters = sessionStorage.getItem("taskManageTableFilters");
      if (!rawFilters) return 0;
      const parsed = JSON.parse(rawFilters);

      let count = 0;
      const hasTaskId = Boolean(parsed?.taskIdFilter?.trim() || parsed?.taskIdInputValue?.trim());
      if (hasTaskId) count += 1;
      if (parsed?.createdByFilter?.trim()) count += 1;
      if (parsed?.sourceFilter && parsed.sourceFilter !== "Everything") count += 1;

      count += Object.entries(parsed?.inputFilters || {})
        .filter(([key, value]) => {
          if (["taskId", "created_By", "createdByFilter", "sourceFilter"].some(k => k.toLowerCase() === key.toLowerCase())) {
            return false;
          }
          return String(value || "").trim() !== "";
        }).length;
      // Per-column funnel filters. countActiveColumnFilters applies the same
      // drop rules the request payload uses, so the badge can never claim a
      // filter that isn't actually being sent.
      count += countActiveColumnFilters(parsed?.columnFilterModel);

      return count;
    } catch {
      return 0;
    }
  }, []);

  useEffect(() => {
    const refreshFilterIndicator = () => {
      const count = computeActiveTableFilterCount();
      setActiveTableFilterCount(count);
      setHasActiveTableFilters(count > 0);
    };

    refreshFilterIndicator();
    window.addEventListener("taskManageFiltersChanged", refreshFilterIndicator);
    window.addEventListener("storage", refreshFilterIndicator);
    return () => {
      window.removeEventListener("taskManageFiltersChanged", refreshFilterIndicator);
      window.removeEventListener("storage", refreshFilterIndicator);
    };
  }, [computeActiveTableFilterCount]);

  const hasAnyFilterApplied = useMemo(() => {
    const hasPriorityFilter = Boolean(priority && priority !== "Everything" && priority !== "Priority");
    const hasStatusFilter = Boolean(active && active !== "Everything" && active !== "Status");
    const hasAccountFilter = Boolean(accountNo?.trim());
    const hasAreaFilter = Boolean(areaCode?.trim() || areainputValue?.trim());
    const hasAssigneeFilter = Boolean(assigneeId || context?.selectedUserId);
    const hasDateFilter = Boolean(fromDate || toDate);
    const hasAiFilter = Boolean(aiSourceFilter?.trim());
    const hasMissingLatLngFilter = Boolean(provideTasksWithMissingLatAndLong);

    return (
      hasPriorityFilter ||
      hasStatusFilter ||
      hasAccountFilter ||
      hasAreaFilter ||
      hasAssigneeFilter ||
      hasDateFilter ||
      hasAiFilter ||
      hasMissingLatLngFilter ||
      hasActiveTableFilters
    );
  }, [
    priority,
    active,
    accountNo,
    areaCode,
    areainputValue,
    assigneeId,
    context?.selectedUserId,
    fromDate,
    toDate,
    aiSourceFilter,
    provideTasksWithMissingLatAndLong,
    hasActiveTableFilters,
  ]);

  const appliedFilterCount = useMemo(() => {
    let count = 0;

    if (priority && priority !== "Everything" && priority !== "Priority") count += 1;
    if (active && active !== "Everything" && active !== "Status") count += 1;
    if (accountNo?.trim()) count += 1;
    if (areaCode?.trim() || areainputValue?.trim()) count += 1;
    if (assigneeId || context?.selectedUserId) count += 1;
    if (fromDate || toDate) count += 1;
    if (aiSourceFilter?.trim()) count += 1;
    if (provideTasksWithMissingLatAndLong) count += 1;

    return count + activeTableFilterCount;
  }, [
    priority,
    active,
    accountNo,
    areaCode,
    areainputValue,
    assigneeId,
    context?.selectedUserId,
    fromDate,
    toDate,
    aiSourceFilter,
    provideTasksWithMissingLatAndLong,
    activeTableFilterCount,
  ]);

  const handleAiSearch = () => {
    const query = aiSearchQuery.trim();

    if (!query) {
      setAiSourceFilter("");
      setActive("Everything");
      setFinishedStatus("Everything");
      setPriority("Everything");
      setIsAiSearchOpen(false);
      return;
    }

    applyKeywordFilters(query);
    setIsAiSearchOpen(false);
  };

  useEffect(() => {
    if (!aiSearchInitializedRef.current) {
      aiSearchInitializedRef.current = true;
      return;
    }
    if (!aiSearchQuery.trim()) {
      setAiSourceFilter("");
      setActive("Everything");
      setFinishedStatus("Everything");
      setPriority("Everything");
      setIsAiSearchOpen(false);
    }
  }, [aiSearchQuery, setAiSourceFilter, setActive, setFinishedStatus, setPriority]);

  //activity
  useEffect(() => {
    const fetchActivityList = async () => {
      try {
        const data = await getActivityListByProjectId(projectId);
        // body.value is a message string ("no data found") rather than a list
        // when the workflow has no activities. A string passes an `?.length`
        // truthiness guard but has no .filter, which crashed the toolbar.
        setActivity(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error("Error fetching departments:", error);
        setActivity([]);
      }
    };
    if (projectId !== null) {
      fetchActivityList(); // Trigger the project fetch whenever `userInfo.organization` changes
    }
  }, [projectId]);

  // Activities the logged-in user is permitted to see (from localStorage userDetails.workflowList).
  const permittedActivity = useMemo(() => {
    return getPermittedActivities(activity);
  }, [activity]);

  const defaultActivityValue = useMemo(() => {
    if (projectId !== null && activityId && Array.isArray(permittedActivity) && permittedActivity.length) {
      const activityIdList = typeof activityId === 'string'
        ? activityId.split(',')
        : Array.isArray(activityId)
          ? activityId.map(id => id.toString())
          : [activityId?.toString()];

      return (permittedActivity || [])
        ?.filter((org) => activityIdList.includes(org.workflowId?.toString()))
        .map((dept) => ({
          value: dept.workflowId,
          label: dept.workflowName,
        }));
    }
    return [];
  }, [projectId, activityId, permittedActivity]);

  // Render the activity/workflow select into the top header bar instead of this toolbar,
  // and clear it on unmount so it doesn't leak into pages without this toolbar.
  //
  // Deliberately skip (rather than null out) the header slot while
  // activityLoader is transiently true: routing this through `null` tore
  // down and rebuilt the whole ActivitySelect component every time
  // activityLoader flipped, which re-ran its internal get-activities fetch
  // from scratch each time -- even though projectId itself hadn't changed.
  // Leaving the previous element in place until the new one is ready avoids
  // that remount/refetch and a visible flicker.
  useEffect(() => {
    if (!setHeaderActivitySelect) return undefined;

    if (activityLoader) {
      return undefined;
    }

    setHeaderActivitySelect(
      <ActivitySelect
        setWorkflowName={setWorkflowName}
        workflowName={workflowName}
        selectedOrgId={selectedOrgId}
        showPlaceholder={true}
        placeholder={translations[langMode]?.allActivity || translations[langMode]?.Activities || "All Activity"}
        optionData={projectId !== null ? permittedActivity : []}
        defaultValue={defaultActivityValue}
        height="42px"
        menuPortalTarget={document.body}
        classNamePrefix="select"
        rounded="rounded-lg !w-full !max-w-none"
        classNames={{
          control: () => "!rounded-lg !bg-white !font-semibold !text-slate-700 border !border-slate-300 !shadow-sm"
        }}
      />
    );

    return () => setHeaderActivitySelect(null);
  }, [
    setHeaderActivitySelect,
    activityLoader,
    setWorkflowName,
    workflowName,
    selectedOrgId,
    langMode,
    projectId,
    permittedActivity,
    defaultActivityValue,
  ]);

  return (
    <>
      <Joyride
        steps={tasktollbar}
        run={runTour}
        continuous
        showSkipButton
        showProgress
        scrollToFirstStep
        styles={{
          options: {
            arrowColor: "#fff",
            zIndex: 10000,
            overlayColor: "rgba(0, 0, 0, 0.5)",
            primaryColor: "#4C3BCF",
            textColor: "#333",
          },
          tooltip: {
            borderRadius: "8px",
            transition: "transform 0.3s ease, opacity 0.3s ease",
          },
          buttonSkip: {
            color: "#4C3BCF",
          },
          buttonNext: {
            backgroundColor: "#4C3BCF",
            transition: "background-color 0.3s ease",
          },
          buttonBack: {
            color: "#4C3BCF",
          },
          spotlight: {
            transition: "box-shadow 0.5s ease",
          },
        }}
      />
      <div className="mx-2 mt-2 min-w-0 shrink-0 rounded-xl border border-slate-200 bg-white px-3 py-3 shadow-sm flex flex-col gap-3 sm:mx-3 sm:mt-2 sm:px-4 sm:py-3 sm:gap-3">
        <div className="flex flex-col xl:flex-row xl:items-start xl:justify-between gap-3">
          <div className="flex items-start justify-between gap-2 min-w-0 w-full xl:w-auto xl:flex-1">
            <div className="min-w-0 flex-1">
              <h1 className="text-base font-bold text-slate-800 leading-tight sm:text-lg">
                {translations[langMode]?.taskManagement ?? "Task Management"}
              </h1>
              <p className="text-xs text-slate-500 mt-0.5">
                {translations[langMode]?.taskManagementSubtitle ?? "Track, assign and export field service tasks across your team."}
              </p>
            </div>
            {/* On mobile and tablet (< xl), place Map / List toggle right next to title */}
            <div className="inline-flex h-9 items-center gap-1 rounded-lg border border-slate-200 bg-white p-1 shadow-sm shrink-0 xl:hidden">
              <button
                onClick={handleMapView}
                title={translations[langMode]?.mapView ?? "Map view"}
                className={`flex h-7 w-[42px] items-center justify-center rounded-md bg-white text-[#236DB4] transition-all duration-200 hover:bg-blue-50 ${theme === "dark"
                    ? " bg-blue-800 "
                    : theme === "high-contrast"
                      ? "bg-black "
                      : ""
                  }`}
              >
                <svg width="16" height="16" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path d="M14.0813 5.6259L7.90625 1.67578L1.375 6.1875V20.625L7.91871 16.3741L14.0938 20.3242L20.625 15.8125V1.375L14.0813 5.6259ZM13.4062 18.0898L8.59375 14.9961V3.91016L13.4062 7.00391V18.0898Z" fill="currentColor" />
                </svg>
              </button>
              <button
                title={translations[langMode]?.listView ?? "List view"}
                className={`flex h-7 w-[42px] items-center justify-center rounded-md bg-[#236DB4] text-white shadow-sm transition-all duration-200 ${theme === "dark"
                    ? "dark-mode "
                    : theme === "high-contrast"
                      ? "high-contrast "
                      : ""
                  }`}
              >
                <List size={16} />
              </button>
            </div>
          </div>

          {/* Action buttons row */}
          <div className={`flex w-full min-w-0 items-center justify-start sm:justify-end gap-1.5 sm:gap-2 flex-wrap sm:flex-nowrap xl:w-auto ${isRtl ? "xl:mr-auto" : "xl:ml-auto"}`}>
            {/* Desktop Map / List toggle (hidden on < xl) */}
            <div className="hidden xl:inline-flex h-9 items-center gap-1 rounded-lg border border-slate-200 bg-white p-1 shadow-sm shrink-0">
              <button
                onClick={handleMapView}
                title={translations[langMode]?.mapView ?? "Map view"}
                className={`flex h-7 w-[48px] items-center justify-center rounded-md bg-white text-[#236DB4] transition-all duration-200 hover:bg-blue-50 ${theme === "dark"
                    ? " bg-blue-800 "
                    : theme === "high-contrast"
                      ? "bg-black "
                      : ""
                  }`}
              >
                <svg width="16" height="16" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path d="M14.0813 5.6259L7.90625 1.67578L1.375 6.1875V20.625L7.91871 16.3741L14.0938 20.3242L20.625 15.8125V1.375L14.0813 5.6259ZM13.4062 18.0898L8.59375 14.9961V3.91016L13.4062 7.00391V18.0898Z" fill="currentColor" />
                </svg>
              </button>
              <button
                title={translations[langMode]?.listView ?? "List view"}
                className={`flex h-7 w-[48px] items-center justify-center rounded-md bg-[#236DB4] text-white shadow-sm transition-all duration-200 ${theme === "dark"
                    ? "dark-mode "
                    : theme === "high-contrast"
                      ? "high-contrast "
                      : ""
                  }`}
              >
                <List size={16} />
              </button>
            </div>

            <div className="flex min-w-0 w-full sm:w-auto items-center justify-start sm:justify-end gap-1.5 sm:gap-2 flex-wrap sm:flex-nowrap">
              {isSuperAdmin() && (
                <CommonButton colorIntent="primary"
                  variant="outline"
                  tooltipPosition="top"
                  tooltipText={translations[langMode]?.columnAccessManagementTitle ?? "Column Access Management"}
                  onClick={() => setIsColumnAccessModalOpen(true)}
                  wrapperClassName="shrink-0"
                  className="!rounded-lg !h-9 !w-9 sm:!w-auto !p-0 sm:!px-3 !justify-center !gap-1.5 sm:!gap-2 !shrink-0"
                  data-testid="access-management-button"
                >
                  <ShieldCheck size={16} className="shrink-0" />
                  <span className="hidden sm:inline text-xs sm:text-sm font-medium whitespace-nowrap">
                    {translations[langMode]?.accessManagementBtn ?? "Access Control"}
                  </span>
                </CommonButton>
              )}
              <CommonButton colorIntent="primary"
                variant="outline"
                tooltipPosition="top" tooltipText={translations[langMode].donwloadthetaskrecordin}
                onClick={handleShowModal}
                disabled={isLoading}
                data-testid="export-button"
                wrapperClassName="flex-1 sm:flex-none"
                className="!rounded-lg !w-full sm:!w-auto !justify-center !px-2.5 sm:!px-3 !gap-1.5 sm:!gap-2 !shrink-0 disabled:opacity-50 disabled:cursor-not-allowed">
                <span className="inline text-xs sm:text-sm font-medium whitespace-nowrap">
                  {exportButtonLabel}</span>
                <svg className="w-4 h-4 text-gray-500 shrink-0" fill="none" stroke="currentColor"
                  viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round"
                    strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" /></svg>
              </CommonButton>
              <CommonButton colorIntent="primary"
                variant="outline"
                tooltipPosition="top" tooltipText={translations[langMode].uploadthetasksheet} onClick={handleGoCsv}
                wrapperClassName="flex-1 sm:flex-none"
                className="!rounded-lg !w-full sm:!w-auto !justify-center !px-2.5 sm:!px-3 !gap-1.5 sm:!gap-2 !shrink-0 disabled:opacity-50 disabled:cursor-not-allowed"
                disabled={!customVarPerm?.canCreate}
                data-testid="import-csv-button">
                <span className="inline text-xs sm:text-sm font-medium whitespace-nowrap">{translations[langMode]?.importBtn ?? "Import"}</span>
                <svg className="w-4 h-4 text-gray-500 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 10l7-7m0 0l7 7m-7-7v18" /></svg>
              </CommonButton>
              <CommonButton colorIntent="primary"
                onClick={handleGoCreateTask}
                variant="primary"
                tooltipText={translations[langMode].createtaskbulk} tooltipPosition="top"
                wrapperClassName="flex-1 sm:flex-none"
                className="!rounded-lg !w-full sm:!w-auto !justify-center !px-2.5 sm:!px-3 !gap-1.5 sm:!gap-2 !shrink-0 disabled:opacity-50 disabled:cursor-not-allowed" data-testid='add-task-button'
                disabled={!(customVarPerm?.canCreate || customVarPerm?.canBulkReAssign || customVarPerm?.canBulkPriorityUpdate)}>
                <svg className="w-4 h-4 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" /></svg>
                <span className="inline whitespace-nowrap text-xs sm:text-sm font-medium" data-testid="add-task-button-text">
                  {translations[langMode]?.addTaskBtn ?? "Add Task"}
                </span>
              </CommonButton>
            </div>
          </div>
        </div>
            {/* More actions button/menu intentionally hidden.
            <Menu as="div" className="relative shrink-0" >
              <div>
                <Menu.Button
                  className={`inline-flex h-9 w-9 items-center justify-center rounded-lg border transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#236DB4]/30 ${
                    theme === "dark"
                      ? "dark-mode border-white text-white bg-gray-800"
                      : theme === "high-contrast"
                        ? "bg-yellow-300 border-black text-black"
                        : "border-slate-200 bg-white text-slate-600 hover:bg-slate-50"
                  }`}
                  aria-label={translations[langMode]?.moreActions ?? "More actions"}
                >
                  <EllipsisVertical size={18} />
                </Menu.Button>
              </div>
              <Transition
                as={Fragment}
                enter="transition ease-out duration-100"
                enterFrom="transform opacity-0 scale-95"
                enterTo="transform opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="transform opacity-100 scale-100"
                leaveTo="transform opacity-0 scale-95"
              >
                <Menu.Items
                  className={` ${theme === "dark"
                    ? "dark-mode border "
                    : theme === "high-contrast"
                      ? "high-contrast  "
                      : ""
                    } absolute ${isRtl ? "left-0 origin-top-left " : "right-0 origin-top-right "} z-[60] mt-1.5 w-56 rounded-xl border border-slate-100 bg-white py-1.5 shadow-xl
                 focus:outline-none`}
                >
                  <Menu.Item
                    className={` ${theme === "dark"
                      ? "dark-mode hover:text-indigo-700 "
                      : theme === "high-contrast"
                        ? "high-contrast  "
                        : ""
                      }`}
                  >
                    {({ active }) => (
                      <Link
                        to=""
                        className={classNames(
                          active ? "bg-slate-50" : "",
                          "flex px-3.5 py-2 mx-1 rounded-lg text-sm font-medium gap-2.5 items-center text-nowrap",
                          finishedStatus === "Finished" ? "hidden" : "",
                          customVarPerm?.canUpdate ? "text-slate-700" : "cursor-not-allowed text-slate-300"
                        )}
                        disabled={!customVarPerm?.canUpdate}
                        onClick={handleAssignClick}
                      >
                        <User size={16} />
                        {translations[langMode].assign}
                      </Link>
                    )}
                  </Menu.Item>
                  <Menu.Item
                    className={` ${theme === "dark"
                      ? "dark-mode hover:text-indigo-700 "
                      : theme === "high-contrast"
                        ? "high-contrast  "
                        : ""
                      }`}
                  >
                    {({ active }) => (
                      <Link
                        to=""
                        className={classNames(
                          active ? "bg-slate-50" : "",
                          "flex px-3.5 py-2 mx-1 rounded-lg text-sm font-medium gap-2.5 items-center text-nowrap",
                          finishedStatus === "Finished" ? "hidden" : "",
                          customVarPerm?.canUpdate ? "text-slate-700" : "cursor-not-allowed text-slate-300"
                        )}
                        disabled={!customVarPerm?.canUpdate}
                        onClick={handleReassignClick}
                      >
                        <Repeat size={16} />
                        {translations[langMode].reassign}
                      </Link>
                    )}
                  </Menu.Item>
                  <Menu.Item
                    className={` ${theme === "dark"
                      ? "dark-mode hover:text-indigo-700 "
                      : theme === "high-contrast"
                        ? "high-contrast  "
                        : ""
                      }`}
                  >
                    {({ active }) => (
                      <Link
                        to=""
                        className={classNames(
                          active ? "bg-slate-50" : "",
                          "flex px-3.5 py-2 mx-1 rounded-lg text-sm font-medium gap-2.5 items-center text-nowrap",
                          finishedStatus === "Finished" ? "hidden" : "",
                          customVarPerm?.canUpdate ? "text-slate-700" : "cursor-not-allowed text-slate-300"
                        )}
                        disabled={!customVarPerm?.canUpdate}
                        onClick={() => {
                          handleUnassignButtonClick()
                        }}
                      >
                        <UserX size={16} />
                        {translations[langMode].unassignn}
                      </Link>
                    )}
                  </Menu.Item>
                  <Menu.Item
                    className={` ${theme === "dark"
                      ? "dark-mode hover:text-indigo-700 "
                      : theme === "high-contrast"
                        ? "high-contrast  "
                        : ""
                      }`}
                  >
                    {({ active }) => (
                      <Link
                        to=""
                        className={classNames(
                          active ? "bg-slate-50" : "",
                          "flex px-3.5 py-2 mx-1 rounded-lg text-sm font-medium gap-2.5 items-center",
                          customVarPerm?.canUpdate ? "text-slate-700" : "cursor-not-allowed text-slate-300"
                        )}
                        disabled={!customVarPerm?.canUpdate}
                        onClick={handleOnHoldClick}
                      >
                        <PauseCircle size={16} />
                        {translations[langMode].onhold}
                      </Link>
                    )}
                  </Menu.Item>
                  <div className="my-1 border-t border-slate-100" />
                  <Menu.Item
                    className={` ${theme === "dark"
                      ? "dark-mode hover:text-indigo-700 "
                      : theme === "high-contrast"
                        ? "high-contrast  "
                        : ""
                      }`}
                  >
                    {({ active }) => (
                      <Link
                        to=""
                        className={classNames(
                          active ? "bg-red-50" : "",
                          "flex px-3.5 py-2 mx-1 rounded-lg text-sm font-medium gap-2.5 items-center",
                          customVarPerm?.canDelete ? "text-red-600" : "cursor-not-allowed text-slate-300"
                        )}
                        disabled={!customVarPerm?.canDelete}
                        onClick={() => showDeleteModal("single", null)}
                      >
                        <Trash2 size={16} />
                        {translations[langMode].delete}
                      </Link>
                    )}
                  </Menu.Item>
                  {(userType === "super_admin" || userType === "admin") && (
                    <Menu.Item>{({ active }) => (
                      <Link to="" className={classNames(active ? "bg-red-50" : "", "flex px-3.5 py-2 mx-1 rounded-lg text-sm font-medium gap-2.5 items-center", customVarPerm?.canDelete ? "text-red-600" : "cursor-not-allowed text-slate-300")} disabled={!customVarPerm?.canDelete} onClick={() => showDeleteModal("all", activityId)}><Trash size={16} />{deleteAllLabel}</Link>
                    )}</Menu.Item>
                  )}
                </Menu.Items>
              </Transition>
            </Menu>
            */}

        {/* Toolbar row: category, task count, filters, lat/long, search — Reset + Columns on the trailing edge */}
        <div className="flex min-w-0 items-center justify-between flex-wrap gap-3">
          <div className="flex min-w-0 w-full items-center gap-2.5 flex-wrap xl:w-auto xl:flex-1">
            <span className="text-sm font-medium text-slate-600 whitespace-nowrap">
              {(renderedTaskCount ?? totalPageSize) ?? 0} {translations[langMode]?.tasksLabel ?? "tasks"}
            </span>

            {/* "Filters" flyout (Priority/Status only) commented out -- redundant with
                the "Column Filters" button's per-column funnel icons, which already
                cover Priority and Status plus every other column. Left in place
                (not deleted) in case we want it back.
            <div ref={filtersToggleRef} className="relative">
              <button
                type="button"
                onClick={() => setIsFiltersFlyoutOpen((o) => !o)}
                aria-expanded={isFiltersFlyoutOpen}
                aria-label={filtersTooltipText}
                className={`flex items-center gap-1.5 px-3 py-2 text-sm font-medium rounded-lg border relative transition-colors ${
                  isFiltersFlyoutOpen || (priority && priority !== "Everything") || (active && active !== "Everything")
                    ? "bg-blue-50 border-[#236DB4] text-[#236DB4]"
                    : "text-slate-600 border-slate-200 bg-white hover:bg-slate-50"
                }`}
              >
                <SlidersHorizontal size={14} />
                {filtersTooltipText}
                {activeTableFilterCount > 0 && (
                  <span className="ml-0.5 text-[10px] font-bold bg-[#236DB4] text-white rounded-full w-4 h-4 flex items-center justify-center">
                    {activeTableFilterCount > 9 ? "9+" : activeTableFilterCount}
                  </span>
                )}
              </button>
              {isFiltersFlyoutOpen && (
                <div className={`absolute z-30 mt-1.5 w-[min(18rem,calc(100vw-2rem))] bg-white border border-slate-200 rounded-xl shadow-xl p-4 ${isRtl ? "right-0" : "left-0"}`} onClick={(e) => e.stopPropagation()}>
                  <p className="text-[11px] font-bold uppercase tracking-wide text-slate-400 mb-2">{translations[langMode]?.priority ?? "Priority"}</p>
                  <div className="flex flex-wrap gap-1.5 mb-3.5">
                    {priorityoptions.filter((p) => p.id !== "Everything").map((p) => (
                      <button
                        key={p.id}
                        type="button"
                        onClick={() => setPriority(priority === p.id ? "Everything" : p.id)}
                        className={`px-3 py-1.5 rounded-full text-xs font-semibold border transition-colors ${
                          priority === p.id
                            ? "bg-[#236DB4] text-white border-[#236DB4]"
                            : "bg-slate-50 text-slate-600 border-slate-200 hover:border-slate-300"
                        }`}
                      >
                        {p.value}
                      </button>
                    ))}
                  </div>
                  <p className="text-[11px] font-bold uppercase tracking-wide text-slate-400 mb-2">{translations[langMode]?.status ?? "Status"}</p>
                  <div className="flex flex-wrap gap-1.5 mb-1">
                    {activeoptions.filter((s) => s.id !== "Everything").map((s) => (
                      <button
                        key={s.id}
                        type="button"
                        onClick={() => setActive(active === s.id ? "Everything" : s.id)}
                        className={`px-3 py-1.5 rounded-full text-xs font-semibold border transition-colors ${
                          active === s.id
                            ? "bg-[#236DB4] text-white border-[#236DB4]"
                            : "bg-slate-50 text-slate-600 border-slate-200 hover:border-slate-300"
                        }`}
                      >
                        {s.value}
                      </button>
                    ))}
                  </div>
                  <div className="flex justify-end gap-2 mt-3 pt-3 border-t border-slate-100">
                    <button
                      type="button"
                      onClick={() => { setPriority("Everything"); setActive("Everything"); }}
                      className="px-3 py-1.5 text-xs font-medium text-slate-500 rounded-md hover:bg-slate-50"
                    >
                      {translations[langMode]?.clear ?? "Clear"}
                    </button>
                    <button
                      type="button"
                      onClick={() => setIsFiltersFlyoutOpen(false)}
                      className="px-3.5 py-1.5 text-xs font-semibold text-white bg-[#236DB4] rounded-md hover:bg-[#1d5a96]"
                    >
                      {translations[langMode]?.apply ?? "Apply"}
                    </button>
                  </div>
                </div>
              )}
            </div>
            */}

            <Tooltip
              text={translations[langMode]?.filtersToggleTooltip ?? "Apply filters from the table header"}
              position="top"
            >
              <button data-table-control="filters"
                type="button"
                onClick={onToggleTableFilters}
                aria-pressed={showTableFilters}
                aria-label={translations[langMode]?.filtersToggleTooltip ?? "Apply filters from the table header"}
                className={`flex items-center gap-1.5 px-3 py-2 text-sm font-medium rounded-lg border transition-colors ${
                  showTableFilters
                    ? "bg-blue-50 border-[#236DB4] text-[#236DB4]"
                    : "text-slate-600 border-slate-200 bg-white hover:bg-slate-50"
                }`}
              >
                <Filter size={14} />
                {translations[langMode]?.columnFiltersLabel ?? "Column Filters"}
              </button>
            </Tooltip>

            {typeof setProvideTasksWithMissingLatAndLong === "function" && (
              <label className="flex min-w-0 items-center gap-2 text-xs text-slate-500 cursor-pointer select-none sm:text-sm">
                <input
                  type="checkbox"
                  checked={provideTasksWithMissingLatAndLong}
                  onChange={(e) => setProvideTasksWithMissingLatAndLong(e.target.checked)}
                  className="accent-[#236DB4] w-3.5 h-3.5"
                />
                <span className="leading-tight">{translations[langMode]?.hidelatlog ?? "Show Tasks Without Location (Lat/Long)"}</span>
              </label>
            )}

            <div className="flex h-9 min-w-0 w-full sm:w-[320px] sm:max-w-full" ref={fieldPickerRef}>
              <div className="relative shrink-0">
                <button
                  type="button"
                  onClick={() => setIsFieldPickerOpen((o) => !o)}
                  disabled={!searchFields.length}
                  className={`h-9 flex max-w-[8.5rem] items-center gap-1.5 px-2 sm:max-w-none sm:px-3 bg-slate-50 border border-slate-200 text-xs sm:text-sm font-medium text-slate-600 hover:bg-slate-100 whitespace-nowrap disabled:opacity-60 ${
                    isRtl ? "rounded-r-lg border-l-0" : "rounded-l-lg border-r-0"
                  }`}
                >
                  <span className="max-w-[110px] truncate">{activeSearchField?.label ?? (translations[langMode]?.accountNo ?? "Account No.")}</span>
                  <ChevronDown size={14} className={`text-slate-400 shrink-0 transition-transform ${isFieldPickerOpen ? "rotate-180" : ""}`} />
                </button>
                {isFieldPickerOpen && (
                  <div
                    dir={isRtl ? "rtl" : "ltr"}
                    className={`absolute z-40 mt-1.5 w-[min(15rem,calc(100vw-2rem))] bg-white border border-slate-200 rounded-lg shadow-xl ${
                      isRtl ? "right-0" : "left-0"
                    }`}
                  >
                    <div className="p-2 border-b border-slate-100">
                      <div className="relative flex items-center">
                        <span
                          className={`absolute inset-y-0 flex items-center pointer-events-none text-slate-400 ${
                            isRtl ? "right-2.5" : "left-2.5"
                          }`}
                        >
                          <Search size={14} />
                        </span>
                        <input
                          autoFocus
                          value={fieldPickerQuery}
                          onChange={(e) => setFieldPickerQuery(e.target.value)}
                          placeholder={translations[langMode]?.findAField ?? "Find a field..."}
                          className={`w-full h-8 text-xs border border-slate-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#236DB4]/20 ${
                            isRtl ? "pr-8 pl-2.5" : "pl-8 pr-2.5"
                          }`}
                        />
                      </div>
                    </div>
                    <div className="max-h-56 overflow-y-auto py-1">
                      {filteredSearchFields.length === 0 && (
                        <p className="text-xs text-slate-400 px-3 py-3 text-center">
                          {translations[langMode]?.noFieldsMatch ?? "No fields match"}
                        </p>
                      )}
                      {filteredSearchFields.map((f) => (
                        <button
                          key={f.key}
                          type="button"
                          onClick={() => {
                            searchFields.forEach((field) => {
                              if (field.key !== f.key) field.clear?.();
                            });
                            setSearchFieldKey(f.key);
                            setIsFieldPickerOpen(false);
                            setFieldPickerQuery("");
                          }}
                          className={`w-full flex items-center justify-between gap-2 px-3 py-1.5 text-xs ${
                            isRtl ? "text-right" : "text-left"
                          } hover:bg-slate-50 ${
                            f.key === activeSearchField?.key ? "text-[#236DB4] font-semibold bg-blue-50/60" : "text-slate-700"
                          }`}
                        >
                          <span>{f.label}</span>
                          {f.key === activeSearchField?.key && <Check size={13} className="shrink-0" />}
                        </button>
                      ))}
                    </div>
                  </div>
                )}
              </div>
              <div className="relative h-9 min-w-0 flex-1">
                <button
                  type="button"
                  onClick={() => activeSearchField?.onSearch()}
                  className={`absolute inset-y-0 flex items-center text-slate-400 hover:text-slate-600 focus:outline-none ${
                    isRtl ? "right-2.5" : "left-2.5"
                  }`}
                  aria-label="Search"
                >
                  <Search size={14} />
                </button>
                <input
                  value={activeSearchField?.value ?? ""}
                  onChange={(e) => activeSearchField?.onChange(e.target.value)}
                  onKeyDown={(e) => e.key === "Enter" && activeSearchField?.onSearch()}
                  disabled={!activeSearchField}
                  placeholder={`${translations[langMode]?.search ?? "Search"} ${activeSearchField?.label ?? ""}...`}
                  className={`block w-full h-9 text-sm border border-slate-200 focus:outline-none focus:ring-2 focus:ring-[#236DB4]/20 focus:border-[#236DB4] disabled:opacity-60 ${
                    isRtl
                      ? "pr-8 pl-7 rounded-l-lg border-r-0"
                      : "pl-8 pr-7 rounded-r-lg border-l-0"
                  }`}
                />
                {activeSearchField?.value && (
                  <button
                    type="button"
                    onClick={() => { activeSearchField.onChange(""); }}
                    className={`absolute inset-y-0 flex items-center text-slate-400 hover:text-slate-600 ${
                      isRtl ? "left-2" : "right-2"
                    }`}
                  >
                    <X size={13} />
                  </button>
                )}
              </div>
            </div>
          </div>

          <div className="flex flex-wrap items-center gap-1.5 sm:gap-2 w-full sm:w-auto sm:h-9 sm:items-stretch sm:justify-end sm:shrink-0">
            {customVarPerm?.canDelete && (userType === "super_admin" || userType === "admin") && (
              <CommonTooltip text={deleteAllTooltip} position="top" disableDefaultDescription fitContent clampToViewport hoverOnly tooltipClassName="w-max max-w-[min(12rem,calc(100vw-1.5rem))] [text-wrap:balance]">
                <button
                  type="button"
                  data-button-intent="danger"
                  onClick={() => showDeleteModal("all", activityId)}
                  className="flex items-center justify-center gap-1 sm:gap-1.5 h-9 px-3 text-xs sm:text-sm font-medium text-red-600 bg-white border border-red-200 rounded-lg hover:bg-red-50 transition-colors whitespace-nowrap"
                >
                  <Trash size={14} /> {deleteAllLabel}
                </button>
              </CommonTooltip>
            )}
            <CommonButton
              variant="outline"
              colorIntent="warning"
              onClick={handleResetFiltersOnly}
              tooltipText={translations[langMode]?.resetAllAppliedFiltersTooltip ?? "Clear all applied filters"}
              tooltipPosition="top"
              className="!relative !h-9 !min-h-[36px] !px-2 sm:!px-3 !py-0 !rounded-lg !border !border-slate-200 !bg-white !text-slate-600 !text-xs sm:!text-sm !font-medium hover:!bg-slate-50 !transition-colors whitespace-nowrap !shadow-none justify-center"
            >
              <span className="inline-flex items-center gap-1 sm:gap-1.5"><RotateCcw size={13} />{translations[langMode]?.reset ?? "Reset"}</span>
              {hasAnyFilterApplied && appliedFilterCount > 0 && (
                <span
                  className={`absolute -top-2 ${isRtl ? "-left-2" : "-right-2"} grid min-w-[20px] h-5 px-1 place-items-center rounded-full bg-[#ff3b30] text-white text-[11px] font-semibold leading-[20px] tabular-nums`}
                  aria-label={`${appliedFilterCount} applied filters`}
                >
                  {appliedFilterCount > 99 ? "99+" : appliedFilterCount}
                </span>
              )}
            </CommonButton>

            <div ref={columnsButtonRef} className="relative h-9 w-auto">
              <Tooltip
                text={translations[langMode]?.columnsTooltip ?? "Choose which columns appear in the table."}
                position="top"
              >
                <ColumnsButton
                  type="button"
                  onMouseDown={(event) => event.stopPropagation()}
                  onClick={() => setIsColumnsModalOpen((current) => !current)}
                  className="inline-flex h-9 w-auto items-center justify-center gap-1 sm:gap-2 whitespace-nowrap rounded-lg border border-slate-200 bg-white px-2 sm:px-3 py-0 text-xs sm:text-sm font-medium leading-none text-slate-700 transition-colors hover:border-slate-300 hover:bg-slate-50"
                  aria-expanded={isColumnsModalOpen}
                  aria-label={translations[langMode]?.columnsTooltip ?? "Choose which columns appear in the table."}
                >
                  <Columns3 size={14} className="shrink-0" />
                  <span>{translations[langMode]?.columnsLabel ?? "Columns"}</span>
                  {Array.isArray(tableHeaders) && tableHeaders.length > 0 && (
                    <span className="inline-flex h-5 min-w-[26px] sm:min-w-[34px] items-center justify-center rounded-full bg-slate-100 px-1 sm:px-1.5 text-[10px] sm:text-[11px] leading-none tabular-nums text-slate-500">
                      {(visibleColumnKeys?.length || tableHeaders.length)}/{tableHeaders.length}
                    </span>
                  )}
                </ColumnsButton>
              </Tooltip>
              <ColumnsCustomizeModal
                open={isColumnsModalOpen}
                onClose={() => setIsColumnsModalOpen(false)}
                tableHeaders={tableHeaders}
                visibleColumnKeys={visibleColumnKeys}
                onApply={handleApplyColumnsModal}
                langMode={langMode}
                anchorRef={columnsButtonRef}
                emptyStateMessage={
                  noColumnAccess
                    ? (translations[langMode]?.noColumnAccessMessage ??
                      "You do not have access to any columns for this workflow. Please contact your super admin.")
                    : undefined
                }
              />
              {isSuperAdmin() && (
                <ColumnAccessManagementModal
                  open={isColumnAccessModalOpen}
                  onClose={() => setIsColumnAccessModalOpen(false)}
                  projectId={projectId}
                />
              )}
            </div>
          </div>
        </div>

        {isChecked && selectedtask?.length > 0 && (
          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2.5 bg-blue-50 border border-blue-200 rounded-lg p-2.5 sm:px-4 sm:py-2">
            <span className="text-xs sm:text-sm font-semibold text-blue-800 shrink-0">
              {selectedtask.length} {selectedtask.length === 1 ? (translations[langMode]?.taskSelected ?? "task selected") : (translations[langMode]?.tasksSelected ?? "tasks selected")}
            </span>
            <div className="flex min-w-0 items-center gap-1.5 sm:gap-2 flex-wrap">
              {finishedStatus !== "Finished" && customVarPerm?.canUpdate && (
                <>
                  <button data-button-intent="primary" onClick={handleAssignClick} className="flex items-center gap-1 px-2.5 sm:px-3 py-1.5 text-xs sm:text-sm font-medium text-white bg-[#236DB4] rounded-md hover:bg-[#1d5a96] transition-colors">
                    <UserPlus size={14} /> {translations[langMode].assign}
                  </button>
                  <button onClick={handleReassignClick} className="flex items-center gap-1 px-2.5 sm:px-3 py-1.5 text-xs sm:text-sm font-medium text-slate-600 bg-white border border-slate-200 rounded-md hover:bg-slate-50 transition-colors">
                    <UserCog size={14} /> {translations[langMode].reassign}
                  </button>
                  <button onClick={handleUnassignButtonClick} className="flex items-center gap-1 px-2.5 sm:px-3 py-1.5 text-xs sm:text-sm font-medium text-slate-600 bg-white border border-slate-200 rounded-md hover:bg-slate-50 transition-colors">
                    <UserX size={14} /> {translations[langMode].unassignn}
                  </button>
                  <button onClick={handleOnHoldClick} className="flex items-center gap-1 px-2.5 sm:px-3 py-1.5 text-xs sm:text-sm font-medium text-slate-600 bg-white border border-slate-200 rounded-md hover:bg-slate-50 transition-colors">
                    <PauseCircle size={14} /> {translations[langMode].onhold}
                  </button>
                </>
              )}
              {customVarPerm?.canDelete && (
                <>
                  <span className="hidden sm:block w-px h-5 bg-blue-200 mx-0.5" />
                  <button data-button-intent="danger" onClick={() => showDeleteModal("single", null)} className="flex items-center gap-1 px-2.5 sm:px-3 py-1.5 text-xs sm:text-sm font-medium text-red-600 bg-white border border-red-200 rounded-md hover:bg-red-50 transition-colors">
                    <Trash2 size={14} /> {translations[langMode].delete}
                  </button>
                </>
              )}
              <button onClick={handleClearSelection} className="text-slate-400 hover:text-slate-600 p-1.5 ml-auto sm:ml-0" aria-label={translations[langMode]?.clearSelectionAria ?? "Clear selection"}>
                <X size={16} />
              </button>
            </div>
          </div>
        )}
      </div>
      <FieldListModal
        taskData={taskData}
        setTaskData={setTaskData}
        open={open}
        setOpen={setOpen}
        setSelectedTasks={setSelectedTasks}
        selectedtask={selectedtask}
        setselectedtask={setselectedtask}
        setIsChecked={setIsChecked}
        selectedOrgId={selectedOrgId}
        resetFilters={resetFilters}
        resetFiltersAfterAssign={handleResetFiltersOnly}
        setAssigneesToUnassign={setAssigneesToUnassign}
      />
      <ReAssignModal
        setTaskData={setTaskData}
        openReassign={openReassign}
        setOpenReassign={setOpenReassign}
        setSelectedTasks={setSelectedTasks}
        setAssigneesToUnassign={setAssigneesToUnassign}
        selectedtask={selectedtask}
        setselectedtask={setselectedtask}
        setIsChecked={setIsChecked}
        resetFilters={resetFilters}
        resetFiltersAfterAssign={handleResetFiltersOnly}
      />
      {deleteModalOpen && deleteItemType === "all" && (
        <DeleteTask
          deleteFunction={() => handleDeleteAllRecord(deleteItemId)}
          onClose={handleCloseDeleteModal}
          isLoading={isLoader}
          scopeMessage={deleteAllScopeMessage}
          confirmTooltip={deleteAllTooltip}
          comment={comment}
          setComment={setComment}
        />
      )}
      {deleteModalOpen && deleteItemType === "single" && (
        <DeleteTask
          deleteFunction={taskDeleteList}
          onClose={handleCloseDeleteModal}
          comment={comment}
          setComment={setComment}
        />
      )}
      <Modal
        setDownloadModal={setDownloadModal}
        downloadModal={downloadModal}
        downloadFiltration={downloadFiltration}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
        keepOpenAfterDownload
        warningMessage={unfilteredExportWarning}
      />

      {showUnassignModal && (
        <UnassignConfirmationModal
          assignees={assigneesToUnassign}
          groups={availableGroups}
          onClose={() => {
            setShowUnassignModal(false)
            setSelectedAssigneesToUnassign([])
            setSelectedUnassignGroupId(null)
          }}
          onConfirm={handleUnassign}
          selectedAssignees={selectedAssigneesToUnassign}
          onToggleAssignee={handleToggleAssignee}
          onToggleAllAssignees={handleToggleAllAssignees}
          selectedGroupId={selectedUnassignGroupId}
          onSelectGroup={setSelectedUnassignGroupId}
          langMode={langMode}
          resetFilters={resetFilters}
        />
      )}
    </>
  );
};
export default TaskListToolbar;

